module.exports = __webpack_public_path__ + "static/img/0caca.bee9855.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/0caca.png
// module id = 208
// module chunks = 1